<template lang="pug">
.Work
  LerpScroll.clients(:speed="0.8" :amount="0.1")
    WorkHeading.client(v-for="(work, i) in works" :data-slug="work.slug" :key="`work-${i}`" :data="work")
  div(v-for="(work, i) in works")
    video.as-background(:data-slug="work.slug" :key="`work-${i}`" loop muted preload="auto" :poster="work.video_thumbnailImage === '' ? '' : require(`../assets/images/${work.video_thumbnailImage}`)" width="100vw" height="100vh"): source(:src="require(`@/assets/${work.video_thumbnail}`)")
</template>

<script>
import LerpScroll from '@/components/LerpScroll'
import WorkHeading from '@/components/WorkHeading'
import { TimelineLite, Power4 } from 'gsap'

export default {
  name: 'home',
  components: { LerpScroll, WorkHeading },
  data() {
    return {
      works: null,
      hasToAnimate: true
    }
  },
  computed: {
    loadVideos() {
      return !this.$store.state.user.hasTouch
    }
  },
  mounted() {
    this.$emit('navigationName', 'work')
    const container = this.$el.querySelector('.clients')
    const allClients = container.querySelectorAll('.client')

    if (this.hasToAnimate) {
      const tl = new TimelineLite()
      tl.staggerFrom(
        allClients,
        1,
        {
          x: -100,
          color: 'rgba(0, 0, 0, 0.2)',
          ease: Power4.easeOut
        },
        0.05
      )
    }

    if (this.loadVideos) {
      allClients.forEach(link => {
        const video = this.$el.querySelector(
          `video[data-slug="${link.getAttribute('data-slug')}"]`
        )

        link.addEventListener('mouseenter', () => {
          allClients.forEach(c => {
            c.style.opacity = 0.2
          })
          video.play()
          video.style.opacity = 1
          link.style.opacity = 1
          link.style.color = 'white'
        })

        link.addEventListener('mouseleave', () => {
          video.pause()
          video.style.opacity = 0
          allClients.forEach(c => {
            c.style.opacity = 1
            link.style.color = `black`
          })
        })
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  created() {
    this.works = this.$store.state.works
  },
  beforeRouteLeave(to, from, next) {
    const outTL = new TimelineLite({ onComplete: next })
    const allLinks = this.$el.querySelectorAll(`.clients .client`)

    if (to.name === 'client') {
      const slug = to.params.slug
      const link = this.$el.querySelector(
        `.clients .client[data-slug="${slug}"]`
      )

      const otherLinks = [...allLinks].filter(aLink => aLink !== link)
      const videos = this.$el.querySelectorAll('video[data-slug]')

      const containerTop = window
        .getComputedStyle(this.$el.querySelector('.clients'))
        .getPropertyValue('padding-top')

      const translate =
        parseFloat(containerTop) - link.getBoundingClientRect().y

      outTL
        .staggerTo(otherLinks, 1, { autoAlpha: 0 }, 0.15, 0)
        .to(videos, 0.3, { autoAlpha: 0 }, 0.3)
        .to(
          link,
          1,
          { y: translate, color: 'rgba(0, 0, 0, 1)', ease: Power4.easeInOut },
          0.5
        )
    } else {
      allLinks.forEach(link => {
        link.style.opacity = `0.2`
      })
      outTL.staggerTo(
        '.client',
        1,
        { x: -100, autoAlpha: 0, ease: Power4.easeIn },
        0.05
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.clients {
  @include grid(1, 7);
  box-sizing: content-box;
  padding: 5rem 0;

  @include desktop {
    @include grid(2, 6);
  }
}

video {
  opacity: 0;
  object-fit: cover;
  transition: 0.5s $ease-out;
  z-index: 2;
}
</style>
